<template>
	<div class="hello">
		<div class="hello_box">
			<Head :hasProject="false"></Head>
			<div class="contBox">
				<!-- 智慧能源管理平台 -->
				<div class="energy">
					<div class="energy_title">
						<p class="line"></p>
						<h4>智慧工地信息平台</h4>
					</div>
					<div class="warning_box">
						<div class="box_title" @click="toPages('1','/projectExtend')"><span>项目概要</span></div>
						<div class="list list_fitment">
							<div class="list_left">
								<img class="left_logo" src="../../../assets/images/project_ptype.png" />
								<span class="left_txt">项目类型</span>
							</div>
							<div class="list_right"><div class="right_txt">{{ projectData.project_type }}</div></div>
						</div>
						<div class="list list_roadshow">
							<div class="list_left">
								<img class="left_logo" src="../../../assets/images/project_price.png" />
								<span class="left_txt">签约价格</span>
							</div>
							<div class="list_right">
								<div class="right_txt"><span>{{ projectData.project_price }} (元)</span></div>
							</div>
						</div>
						<div class="list list_shangbao">
							<div class="list_left">
								<img class="left_logo" src="../../../assets/images/project_status.png" />
								<span class="left_txt">项目状态</span>
							</div>
							<div class="list_right">
								<div class="right_txt"><span>{{ projectData.status == 0 ? '禁用':'启用' }}</span></div>
							</div>
						</div>
						<div class="list list_parking">
							<div class="list_left">
								<img class="left_logo" src="../../../assets/images/project_classify.png" />
								<span class="left_txt">建设单位</span>
							</div>
							<div class="list_right">
								<div class="right_txt"><span>{{ projectData.construction_unit }}</span></div>
							</div>
						</div>
						<div class="list list_fitment">
							<div class="list_left">
								<img class="left_logo" src="../../../assets/images/project_addr.png" />
								<span class="left_txt">项目地址</span>
							</div>
							<div class="list_right">
								<div class="right_txt"><span>{{ projectData.address?projectData.address:'未录入' }}</span></div>
							</div>
						</div>
						<div class="list list_repairs">
							<div class="list_left">
								<img class="left_logo" src="../../../assets/images/project_date.png" />
								<span class="left_txt">项目工期</span>
							</div>
							<div class="list_right">
								<div class="right_txt"><span>{{ projectData.duration?projectData.duration:'0' }}(天)</span></div>
							</div>
						</div>
					</div>
					<div class="resource_box">
						<div class="box_title" @click="toPages('4','/environment')"><span>环境监测数据</span></div>
						<div class="resource_content">
							<div class="resource_left">
								<div class="resource_left_title">
									<img class="left_title_logo" src="../../../assets/images/title_tip.png" />
									<span>环境监测</span>
								</div>
								<div class="water_electricity">
									<div class="water_electricity_box water_box">
										<div class="water_electricity_title water_title">PM 2.5</div>
										<div class="water_box_count"><span class="water_box_txt1">{{ envData.pm2p5 }}μg/㎡</span></div>
									</div>
									<div class="water_electricity_box electricity_box">
										<div class="water_electricity_title electricity_title">PM 10</div>
										<div class="water_box_count"><span class="water_box_txt1">{{ envData.pm10 }}μg/㎡</span></div>
									</div>
									<div class="water_electricity_box water_box">
										<div class="water_electricity_title water_title">温度</div>
										<div class="water_box_count"><span class="water_box_txt1">{{ envData.temperature }}℃</span></div>
									</div>
									<div class="water_electricity_box electricity_box">
										<div class="water_electricity_title electricity_title">湿度</div>
										<div class="water_box_count"><span class="water_box_txt1">{{ envData.humidity }}%</span></div>
									</div>
								</div>
								<div class="water_electricity" style="margin-top: 5px;">
									<div class="water_electricity_box water_box">
										<div class="water_electricity_title water_title">噪音</div>
										<div class="water_box_count"><span class="water_box_txt1">{{ envData.noise }}分贝</span></div>
									</div>
									<div class="water_electricity_box electricity_box">
										<div class="water_electricity_title electricity_title">风速</div>
										<div class="water_box_count"><span class="water_box_txt1">{{ envData.wind_speed }}m/s</span></div>
									</div>
									<div class="water_electricity_box water_box">
										<div class="water_electricity_title water_title">风向</div>
										<div class="water_box_count"><span class="water_box_txt1">{{ fnToggleText(envData.wind_direction_location) }}</span></div>
									</div>
									<div class="water_electricity_box electricity_box">
										<div class="water_electricity_title electricity_title">风力</div>
										<div class="water_box_count"><span class="water_box_txt1">{{ envData.wind_grade }}级</span></div>
									</div>
								</div>

								<div class="resource_left_title" style="margin-top: 10px;">
									<img class="left_title_logo" src="../../../assets/images/title_tip.png" />
									<span>环境监测曲线图</span>
								</div>
								<div class="resource_right_content">
									<div class="right_content_title">环境监测实时曲线</div>
									<div class="lineData">
										<div id="elevator-chart" class="chart-container" ref="container"></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- 智慧物业管理凭条平台 -->
				<div class="property">
                    <div class="marker_box" style="z-index: 10;" v-if="hasMarker">
                        <MarkerShow :markerPoint="markerPoint"></MarkerShow>
                    </div>
					<div class="property_top" @click="toPages('2','/')" v-else>
						<div class="pic1"></div>
						<div class="pic2"></div>
						<div class="pic3"></div>
						<div class="pic4"></div>
						<div class="pic5">
							<div class="text">{{ title }}</div>
						</div>
						<div class="pic6"></div>
						<div class="pic7"></div>
					</div>
					<div class="property_bottom">
						<div class="property_bottom_title" @click="toPages('3','/monitorscreen')">
							<p class="line"></p>
							<h4>智能监控管理平台</h4>
						</div>
						<div class="property_bottom_content">
							<video
								v-if="monitorUrl[0]&&monitorUrl[0].liveAddress"
								class="video"
								id="myplayer1"
								autoplay="autoplay"
								:src="monitorUrl[0].liveAddress"
								controls
								playsInline
								webkit-playsinline
							>
							</video>
							<img v-else src="../../../assets/images/no.png">
							<video
								v-if="monitorUrl[1]&&monitorUrl[1].liveAddress"
								class="video"
								id="myplayer2"
								autoplay="autoplay"
								:src="monitorUrl[1].liveAddress"
								controls
								playsInline
								webkit-playsinline
							>
							</video>
							<img v-else src="../../../assets/images/no.png">
						</div>
					</div>
				</div>

				<!-- 智慧工地业务平台 -->
				<div class="resources">
					<div class="firstTitle">
						<p class="line"></p>
						<h4>智慧工地业务平台</h4>
					</div>
					<!-- 异常人员统计 -->
					<div class="lease">
						<div class="title" @click="toPages('2','/abnormal')">
							<span v-if="abnormalCount>0">异常人员({{ abnormalCount }}人)</span>
							<span v-else>异常人员</span>
						</div>
						<!-- 异常人员 -->
						<div class="allArea">
							<div class="swiper-containers" v-if="AbnormalPerson.length">
								<div class="swiper-wrapper">
									<div class="swiper-slide" v-for="(item,index) in AbnormalPerson" :key="index" @click="fnGetDetail">
										<div class="abnormal">
											<div class="names">{{ item.name?item.name:'未知' }}</div>
											<div class="avatars">
												<img :src="item.photo || defaultImg"/>
											</div>
											<div class="conts">{{ item.reason?item.reason:'无' }}</div>
											<!-- <div class="btns">
												<button class="btn" @click="fnGetDetail">查看详情</button>
											</div> -->
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- 实时考勤统计 -->
					<div class="attendance" @click="toPages('2','/attendance')">
						<div class="title"><span>实时考勤统计</span></div>
						<div class="attendance-chart" ref="attendanceChart"></div>
					</div>
					<!-- 质量安全统计 -->
					<div class="businessmen">
						<div class="title"><span>质量安全统计</span></div>
						<div class="content-boxs">
							<div class="quality">
								<div class="titles" @click="toPages('5','/quality')">
									<img src="../../../assets/images/title_tip.png"/>
									<span>质量统计</span>
								</div>
								<div class="charts">
									<div class="quality-rate" id="quality-rate-chart" ref="qualityRate"></div>
								</div>
							</div>
							<div class="safety">
								<div class="titles" @click="toPages('6','/safety')">
									<img src="../../../assets/images/title_tip.png"/>
									<span>安全统计</span>
								</div>
								<div class="charts">
									<div class="safety-rate" id="safety-rate-chart" ref="safetyRate"></div>
								</div>
							</div>
						</div>
					</div>
					<!-- 设备统计 -->
					<div class="administrationServer">
						<div class="title"><span>设备统计</span></div>
						<div class="wrapper">
							<div class="huan1 position1" @click="toPages('4','/access')">
								<img src="../../../assets/images/device_entrance.png" alt="" />
								<span class="span1">门禁设备</span>
								<span>{{ eqptData.face.online }}/{{ eqptData.face.total }}</span>
							</div>
							<div class="huan1 position2" @click="toPages('4','/helmet')">
								<img src="../../../assets/images/device_helmet.png" alt="" />
								<span class="span1">AI监测</span>
								<span>{{ eqptData.helmet.online }}/{{ eqptData.helmet.total }}</span>
							</div>
							<div class="huan1 position3" @click="toPages('4','/led')">
								<img src="../../../assets/images/device_led.png" alt="" />
								<span class="span1">LED控制主板</span>
								<span>{{ eqptData.led.online }}/{{ eqptData.led.total }}</span>
							</div>
							<div class="huan1 position4" @click="toPages('3','/monitorscreen')">
								<img src="../../../assets/images/device_monitor.png" alt="" />
								<span class="span1">视频监控</span>
								<span>{{ eqptData.monitor.online }}/{{ eqptData.monitor.total }}</span>
							</div>
							<div class="huan1 position5" @click="toPages('4','/tower')">
								<img src="../../../assets/images/device_tower.png" alt="" />
								<span class="span1">塔机黑匣子</span>
								<span>{{ eqptData.crane.online }}/{{ eqptData.crane.total }}</span>
							</div>
							<div class="huan1 position6" @click="toPages('4','/environment')">
								<img src="../../../assets/images/device_env.png" alt="" />
								<span class="span1">环境监测</span>
								<span>{{ eqptData.env.online }}/{{ eqptData.env.total }}</span>
							</div>
							<div class="huan1 position7" @click="toPages('4','/elevator')">
								<img src="../../../assets/images/device_lift.png" alt="" />
								<span class="span1">施工升降机</span>
								<span>{{ eqptData.elevator.online }}/{{ eqptData.elevator.total }}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
var that;
import request from '@/utils/request';
import axios from 'axios';
import Swipers from 'swiper'
import Head from '@/views/Header/HeaderDefault/headerProject';
import echarts from 'echarts';
import EZUIKit from '../../../../static/ezuikit.js'
import cryptoJs from 'crypto-js'
import { fnCookie } from '@/utils/localStorage'
import { getUserInfo, setActiveIndex } from '@/utils/auth'
import MarkerShow from './markerShow.vue'
export default {
	name: 'index',
	data() {
		return {
			userInfo:null,// 用户信息
			title: '筑工匠',// 中间企业名字
			projectData:{},// 项目概要数据
			envData: {// 环境监测数据
				pm2p5: '0',			// pm2.5
				pm10: '0',				// pm10
				temperature: '0',				// 温度
				humidity: '0', 	// 湿度
				noise: '0',			// 噪音
				wind_speed: '0',			// 风速
				wind_direction_location: '无',// 风向
				wind_grade: '0'				// 风力
			},
			timers:null,// 环境监测实时请求
			chartDataX: [],// 环境监测 -> 统计图X轴数据
			pm25Y: [],// 环境监测 -> 统计图pm25数据
			pm10Y: [],// 环境监测 -> 统计图pm10数据
			noiseY: [],// 环境监测 -> 统计图噪音数据
			tempY: [],// 环境监测 -> 统计图温度数据
			wetY: [],// 环境监测 -> 统计图湿度数据
			EnviromentChart: null,// 环境监测统计图
			monitorToken:'',// 获取视频监控token
			eqptData:{// 设备统计数据
				face:{ online:0, total:0 },// 人脸
				access:{ online:0, total:0 },// 门禁
				led:{ online:0, total:0 },// led控制主板
				monitor:{ online:0, total:0 },// 监控
				crane:{ online:0, total:0 },// 塔机
				env:{ online:0, total:0 },// 环境监测
				elevator:{ online:0, total:0 },// 升降机
				helmet:{ online:0, total:0 }// 安全帽
			},
			AbnormalPerson:[],// 异常人员
			abnormalCount:0,// 异常人员数量
			defaultImg: 'http://cqxtkj.oss-cn-chengdu.aliyuncs.com/image/40fd31b9434de0d6cc965f1c2b475368.jpg', // 默认头像
			attendanceChart: null,// 实时考勤统计折线图
			teamData: [],// 班组 -> 实时考勤统计
			teamDataLine: [],// 班组半透明柱状图总人数 -> 实时考勤统计
			teamDataBar: [],// 班组实心柱状图打卡人数 -> 实时考勤统计
			teamDataRate: [],// 班组折线图打卡率 -> 实时考勤统计
			safetyRateChart: null,// 安全统计图
			safety:{
				safetyTotal: 0,// 安全统计 总数
				safetyTimeout: 0,// 安全统计 超时整改数
				safetyTime: 0,// 安全统计 准时整改数
				safetyIng: 0,// 安全统计 整改中
				safetyNot: 0,// 安全统计 未整改
			},
			qualityRateChart: null,// 质量统计图
			quality:{
				qualityTotal: 0,// 质量统计 总数
				qualityTimeout: 0,// 质量统计 超时整改数
				qualityTime: 0,// 质量统计 准时整改数
				qualityIng: 0,// 质量统计 整改中
				qualityNot: 0,// 质量统计 未整改
			},
			monitorUrl:[],// 视频监控地址
			myplayer1:null,// 监控一
			myplayer2:null,// 监控二
            markerPoint: {},// 标点数据
            markerPointAll: null,
            hasMarker: false,
		};
	},
	components: {
		Head,
		Swipers,
        MarkerShow
	},
	created: function() {
		that = this;
	},
	mounted() {
		// 初始化
		that.fnInit()
	},
	beforeDestroy() {
		clearInterval(that.timers);
		// 结束
		if(that.myplayer1){
			that.myplayer1.stop();
		}
		if(that.myplayer2){
			that.myplayer2.stop();
		}
	},
	methods: {
		// 页面跳转
		toPages(index,path) {
			setActiveIndex(index)
			this.$router.push({ path: path});
		},
		// 初始化
		fnInit(){
			// 获取所有区域
			that.fnGetUploadRegion()
			// 获取项目登录信息
			that.userInfo = getUserInfo()
			// 获取企业端名称
			that.title = that.userInfo.enter_name ? that.userInfo.enter_name : '筑工匠'
			// 获取项目概要
			that.fnGetProjectInfo();
			// 获取环境监测设备号
			that.fnGetEnvNumber();
			// 获取异常人员信息
			that.fnGetAbnormal()
			// 获取视频监控video
			that.fnGetMonitorUrl()
			// 获取视频监控设备token地址
			that.fnGetMonitorToken()
			// 获取设备统计数据
			that.fnGetEquipmentData()
			// 获取今日考勤数据 初始化班组进场统计图
			that.fnGetTodayAttendance()
			// 获取安全统计数据
			that.fnGetSafetyData()
			// 获取质量统计数据
			that.fnGetQualityData()
			// 清除timers
			that.timers && clearInterval(that.timers)
            // 获取标点数据
            that.fnGetMarkerPoint()
			// 每秒请求一次环境监测设备号
			that.timers = setInterval(()=>{
				// 获取环境监测设备号
				that.fnGetEnvNumber()
				// 获取今日考勤数据 初始化班组进场统计图
				that.fnGetTodayAttendance()
			},5000)
		},
        // 获取标点数据
        fnGetMarkerPoint(){
            request({
            	url: '/project/getMarker',
            	method: 'GET'
            }).then(res => {
                if(res.code == 1){
                    let _data = res.data
                    let _marker = _data.marker_list ? JSON.parse(_data.marker_list) : []
                    for(let i in _marker){
                        switch (_marker[i].pointType){
                            case '视频监控':
                                _marker[i].url = '/monitorscreen'
                                _marker[i].icon = require('../../../assets/img/icon_monitor.png')
                                _marker[i].type = 'monitor'
                                // _marker[i].x = _marker[i].x * 0.15
                                // _marker[i].y = _marker[i].y * 0.15
                                break;
                            case 'LED设备':
                                _marker[i].url = '/led'
                                _marker[i].icon = require('../../../assets/img/icon_led.png')
                                _marker[i].type = 'led'
                                // _marker[i].x = _marker[i].x * 0.15
                                // _marker[i].y = _marker[i].y * 0.15
                                break;
                            case '塔机设备':
                                _marker[i].url = '/tower'
                                _marker[i].icon = require('../../../assets/img/icon_tower.png')
                                _marker[i].type = 'tower'
                                // _marker[i].x = _marker[i].x * 0.15
                                // _marker[i].y = _marker[i].y * 0.15
                                break;
                            case '升降机设备':
                                _marker[i].url = '/elevator'
                                _marker[i].icon = require('../../../assets/img/icon_elevator.png')
                                _marker[i].type = 'elevator'
                                // _marker[i].x = _marker[i].x * 0.15
                                // _marker[i].y = _marker[i].y * 0.15
                                break;
                            case '环境监测设备':
                                _marker[i].url = '/environment'
                                _marker[i].icon = require('../../../assets/img/icon_environment.png')
                                _marker[i].type = 'environment'
                                // _marker[i].x = _marker[i].x * 0.15
                                // _marker[i].y = _marker[i].y * 0.15
                                break;
                            case 'AI监测':
                                _marker[i].url = '/helmet'
                                _marker[i].icon = require('../../../assets/img/icon_helmet.png')
                                _marker[i].type = 'helmet'
                                // _marker[i].x = _marker[i].x * 0.15
                                // _marker[i].y = _marker[i].y * 0.15
                                break;
                            default:
                                break;
                        }
                    }
                    let _obj = {
                        image: _data.image,
                        imgHeight: _data.img_height*0.15,
                        imgWidth: _data.img_width*0.15,
                        markerList: _marker
                    }
                    this.markerPoint = _obj
                    if(_obj.image!=''&&_obj.markerList.length>0){
                        this.hasMarker = true
                    }
                }
            }).catch(err => {
            	this.$message.error(err.data)
            })
        },
		// 获取上传区域列表
		fnGetUploadRegion () {
			request({
				url: '/attendance/getUploadRegion',
				method: 'GET'
			}).then(res => {
				fnCookie('uploadRegion', res.data)
			}).catch(err => {
				this.$message.error(err.data)
			})
		},
		// 获取项目概要数据
		fnGetProjectInfo(){
			request({
			  url: 'projectIndex/getProjectInfo',
			  method: 'GET'
			}).then(res => {
				this.projectData = res.data
			}).catch(err => {
			  this.$message.error(err.data)
			})
		},
		// 获取环境监测设备号
		fnGetEnvNumber(){
			request({
				url: 'environmental/get',
				method: 'GET',
				params: {
					project_id: that.userInfo.id
				}
			}).then(res => {
				let _number = res.data.query[0] ? res.data.query[0].number : ''
				// 调用获取环境监测数据
				this.fnGetEnvData(_number)
			}).catch(err => {
				this.$message.error(err.data)
			})
		},
		// 获取环境监测数据
		fnGetEnvData(_number){
			if(_number){
				request({
					url: 'eqptCheck/getEnvData',
					method: 'GET',
					params:{
						page: 1,
						size: 20,
						number:_number
					}
				}).then(res => {
					// 环境监测实时数据
					that.envData = res.data[0]
					// 实时曲线图数据
					let _data = res.data
					let _chartDataX = []// 统计图X轴数据
					let _pm25Y = []// 统计图pm25数据
					let _pm10Y = []// 统计图pm10数据
					let _noiseY = []// 统计图噪音数据
					let _tempY = []// 统计图温度数据
					let _wetY = []// 统计图湿度数据

					for(var i=0;i<_data.length;i++){
						_chartDataX.unshift(_data[i].record_at.split(' ')[1])
						_pm25Y.unshift(_data[i].pm2p5)
						_pm10Y.unshift(_data[i].pm10)
						_noiseY.unshift(_data[i].noise)
						_tempY.unshift(_data[i].temperature)
						_wetY.unshift(_data[i].humidity)
					}

					that.chartDataX = _chartDataX
					that.pm25Y = _pm25Y
					that.pm10Y = _pm10Y
					that.noiseY = _noiseY
					that.tempY = _tempY
					that.wetY = _wetY

					that.fnEnviromentChart()

				}).catch(err => {
					let _myDate = new Date().getTime()
					let _index = 0
					let _chartDataX = []
					let _pm25Y = []
					let _pm10Y = []
					let _noiseY = []
					let _tempY = []
					let _wetY = []

					while (_index < 10){
					  _myDate -= 1000 * 10
					  _chartDataX.unshift(new Date(_myDate).Format('hh:mm:ss'))
					  _pm25Y.unshift(0)
					  _pm10Y.unshift(0)
					  _noiseY.unshift(0)
					  _tempY.unshift(0)
					  _wetY.unshift(0)

					  _index++
					}

					that.chartDataX = _chartDataX
					that.pm25Y = _pm25Y
					that.pm10Y = _pm10Y
					that.noiseY = _noiseY
					that.tempY = _tempY
					that.wetY = _wetY

					that.fnEnviromentChart()
				})
			}
		},
		// 环境监测统计图初始化
		fnEnviromentChart() {
			this.EnviromentChart = echarts.init(this.$refs.container);
			this.EnviromentChart.setOption({
				title: {
					top: 20,
					textStyle: {
						fontWeight: 'normal',
						fontSize: 16,
						color: '#F1F1F3'
					},
					left: '1%'
				},
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						lineStyle: {
							color: '#57617B'
						}
					}
				},
				legend: {
					top: '20px',
					textStyle: {
						color: '#fff'
					},
					data: ['pm2.5', 'pm10', '噪音', '温度', '湿度']
				},
				grid: {
					top: 100,
					left: '2%',
					right: '2%',
					bottom: '2%',
					containLabel: true
				},
				xAxis: [
					{
						type: 'category',
						boundaryGap: false,
						axisLine: {
							lineStyle: {
								color: '#fff'
							}
						},
						data: this.chartDataX
					}
				],
				yAxis: [
					{
						type: 'value',
						name: '',
						axisTick: {
							show: false
						},
						axisLine: {
							lineStyle: {
								color: '#fff'
							}
						},
						axisLabel: {
							margin: 10,
							textStyle: {
								fontSize: 14
							}
						},
						splitLine: {
							lineStyle: {
								color: '#57617B'
							}
						}
					}
				],
				series: [
					{
						name: 'pm2.5',
						type: 'line',
						smooth: true,
						symbol: 'circle',
						symbolSize: 5,
						showSymbol: false,
						lineStyle: {
							normal: {
								width: 2
							}
						},
						itemStyle: {
							normal: {
								color: 'rgb(137,189,27)',
								borderColor: 'rgba(137,189,2,0.27)',
								borderWidth: 12
							}
						},
						data: this.pm25Y
					},
					{
						name: 'pm10',
						type: 'line',
						smooth: true,
						symbol: 'circle',
						symbolSize: 5,
						showSymbol: false,
						lineStyle: {
							normal: {
								width: 2
							}
						},
						itemStyle: {
							normal: {
								color: '#fff',
								borderColor: 'rgba(137,189,2,0.27)',
								borderWidth: 12
							}
						},
						data: this.pm10Y
					},
					{
						name: '噪音',
						type: 'line',
						smooth: true,
						symbol: 'circle',
						symbolSize: 5,
						showSymbol: false,
						lineStyle: {
							normal: {
								width: 2
							}
						},
						itemStyle: {
							normal: {
								color: '#F56C6C',
								borderColor: 'rgba(137,189,2,0.27)',
								borderWidth: 12
							}
						},
						data: this.noiseY
					},
					{
						name: '温度',
						type: 'line',
						smooth: true,
						symbol: 'circle',
						symbolSize: 5,
						showSymbol: false,
						lineStyle: {
							normal: {
								width: 2
							}
						},
						itemStyle: {
							normal: {
								color: '#909399',
								borderColor: 'rgba(137,189,2,0.27)',
								borderWidth: 12
							}
						},
						data: this.tempY
					},
					{
						name: '湿度',
						type: 'line',
						smooth: true,
						symbol: 'circle',
						symbolSize: 5,
						showSymbol: false,
						lineStyle: {
							normal: {
								width: 2
							}
						},
						itemStyle: {
							normal: {
								color: '#409EFF',
								borderColor: 'rgba(137,189,2,0.27)',
								borderWidth: 12
							}
						},
						data: this.wetY
					}
				]
			});
		},
		// 环境监测 风力转文字
		fnToggleText(status){
			switch (status){
				case 0:
					return "北风";
				case 1:
					return "东北风";
				case 2:
					return "东风";
				case 3:
					return "东南风";
				case 4:
					return "南风";
				case 5:
					return "西南风";
				case 6:
					return "西风";
				case 7:
					return "西北风";
				default:
					return "无";
			}
		},
		// 获取监控地址token
		fnGetMonitorToken() {
			request({
				url: 'zgj-monitor/get_token',
				method: 'GET'
			})
			.then(res => {
				this.monitorToken = res.data;
			})
			.catch(err => {
				this.$message.error(err.data);
			});
		},
		// 获取视频监控video
		fnGetMonitorUrl(){
			request({
			  url: 'projectIndex/getMonitor',
			  method: 'GET'
			}).then(res => {
				if(res.data.length>0){
					let _data = res.data
					for(var i in _data){
						let _index1 = _data[i].liveAddress.lastIndexOf(':')
						_data[i].liveAddress = 'https' + _data[i].liveAddress.slice(_index1)
						let _index2 = _data[i].hdAddress.lastIndexOf(':')
						_data[i].hdAddress = 'https' + _data[i].hdAddress.slice(_index2)
					}
					that.monitorUrl = _data
					that.$nextTick(()=>{
						if(that.monitorUrl[0]&&that.monitorUrl[0].liveAddress){
							// 开始初始化直播源地址
							that.myplayer1 = new EZUIKit.EZUIPlayer(myplayer1);
							that.myplayer1.play()
						}
						if(that.monitorUrl[1]&&that.monitorUrl[1].liveAddress){
							that.myplayer2 = new EZUIKit.EZUIPlayer(myplayer2);
							that.myplayer2.play()
						}
					})
				}
			}).catch(err => {
			  that.$message.error(err.data)
			})
		},
		// 获取设备统计数据
		fnGetEquipmentData(){
			request({
			  url: 'eqptCheck/getEqptCount',
			  method: 'GET'
			}).then(res => {
				if(res.data){
					let _face = res.data.face
					let _access = res.data.access
					let _obj = {
						online: _face.online + _access.online,
						total: _face.total + _access.total
					}
					// 设备统计数据
					that.eqptData.face = _obj
					// that.eqptData.access = res.data.access
					that.eqptData.crane = res.data.crane
					that.eqptData.env = res.data.env
					that.eqptData.elevator = res.data.elevator
					that.eqptData.led = res.data.led
					that.eqptData.helmet = res.data.helmet
					// 监控设备数据初始化
					that.eqptData.monitor.online = 0
					that.eqptData.monitor.total = 0
					// 循环判断监控设备是否在线
					let _data = res.data.monitor
					for(var i in _data){
						that.eqptData.monitor.total++
						that.fnGetDeviceInfo(_data[i])
					}
				}
			}).catch(err => {
			  that.$message.error(err.data)
			})
		},
		// 从萤石云获取设备信息
		fnGetDeviceInfo(_deviceSerial) {
			let param = new URLSearchParams();
			param.append('accessToken', this.monitorToken);
			param.append('deviceSerial', _deviceSerial);
			axios({
				method: 'post',
				url: 'https://open.ys7.com/api/lapp/device/info',
				data: param
			})
			.then(res => {
				if (res.data.code == 200) {
					if(res.data.data.status == 1){
						that.eqptData.monitor.online+=1
					}
				}
			})
			.catch(err => {
				// this.$message.warning(err.msg);
			});
		},
		// 初始化异常人员轮播
		AbnormalSwiper() {
			new Swipers('.swiper-containers', {
				autoplay: true,
				loop: true,
				direction: 'vertical',
				observer:true,
				observeParents:true,
				onSlideChangeEnd: function(swiper){
					swiper.update();
					swiper.startAutoplay();
					swiper.reLoop();
				}
			})
		},
		// 获取异常人员信息
		fnGetAbnormal(){
			request({
			  url: 'memberError/getErrorListData',
			  method: 'GET'
			}).then(res => {
				let _data = res.data.query
				if(_data.length > 0){
					let _arr = []
					for(var i in _data){
						if(_data[i].state == 0){
							_arr.push(_data[i])
						}
					}
					that.AbnormalPerson = _arr
					that.abnormalCount = _arr.length
					that.$nextTick(()=>{
						// 调用异常人员轮播
						that.AbnormalSwiper()
					})
				}
			}).catch(err => {
			  that.$message.error(err.data)
			})
		},
		// 查看异常人员详情
		fnGetDetail(){
			this.$router.push({ path: '/abnormal'});
		},
		// 初始化实时考勤统计图
		fnAttendanceChart() {
		  let _option = {
		    title: {
		      text: "各班组人员进场统计",
		      x: "center",
		      y: 0,
		      textStyle: {
		        color: "#B4B4B4",
		        fontSize: 12,
		        fontWeight: "normal"
		      }
		    },
		    tooltip: {
		      trigger: "axis",
		      backgroundColor: "rgba(255,255,255,0.1)",
		      axisPointer: {
		        type: "shadow",
		        label: {
		          show: true,
		          backgroundColor: "#7B7DDC"
		        }
		      }
		    },
		    legend: {
		      data: ["在场人数", "总人数", "在场率"],
		      textStyle: {
		        color: "#B4B4B4"
		      },
		      top: "7%"
		    },
		    grid: {
		      x: "12%",
		      width: "85%",
		      left: "7%",
		      y: "20%"
		    },
		    xAxis: {
		      data: this.teamData,
		      axisLine: {
		        lineStyle: {
		          color: "#B4B4B4"
		        }
		      },
		      axisTick: {
		        show: false
		      }
		    },
		    yAxis: [{
					splitLine: { show: false },
					axisLine: {
						lineStyle: {
							color: "#B4B4B4"
						}
					},
					axisLabel: {
						formatter: "{value}"
					}
				},
				{
					name: "在场率(%)",
					splitLine: { show: false },
					axisLine: {
						lineStyle: {
							color: "#B4B4B4"
						}
					},
					axisLabel: {
						formatter: "{value}"
					}
				}
			],
			series: [
				{
					name: "在场率",
					type: "line",
					smooth: true,
					showAllSymbol: true,
					symbol: "emptyCircle",
					symbolSize: 8,
					yAxisIndex: 1,
					itemStyle: {
						normal: {
							color: "#F02FC2"
						}
					},
					data: this.teamDataRate
				},
				{
					name: "在场人数",
					type: "bar",
					barWidth: 20,
					itemStyle: {
						normal: {
							barBorderTopRightRadius: 10,
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{ offset: 0, color: "#956FD4" },
								{ offset: 1, color: "#3EACE5" }
							])
						}
					},
					data: this.teamDataBar
				},
				{
					name: "总人数",
					type: "bar",
					barGap: "-100%",
					barWidth: 20,
					itemStyle: {
						normal: {
							barBorderRadius: 5,
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{ offset: 0, color: "rgba(156,107,211,0.5)" },
								{ offset: 0.2, color: "rgba(156,107,211,0.3)" },
								{ offset: 1, color: "rgba(156,107,211,0)" }
							])
						}
					},
					z: -12,
					data: this.teamDataLine
				}]
		  };
		  this.attendanceChart = echarts.init(this.$refs.attendanceChart);
		  this.attendanceChart.setOption(_option);
		},
		// 获取今日考勤数据
		fnGetTodayAttendance() {
		  request({
		    url: "personnel/getTeamPersonnel",
		    method: "GET",
		  })
			.then(res => {
				if(res.data){
					if(res.data.team){
						let _teamData = res.data.team;
						that.teamData = [];
						that.teamDataLine = [];
						that.teamDataBar = [];
						that.teamDataRate = [];
						for (let _key in _teamData) {
							that.teamData.push(_key);
							that.teamDataLine.push(_teamData[_key]["sum"]);
							let _today = _teamData[_key]['today']?_teamData[_key]['today']:0
							this.teamDataBar.push(_today);

							let _rate = _today / _teamData[_key]['sum'];
							_rate = _rate ? parseInt(_rate * 100) : 0;
							that.teamDataRate.push(_rate == _rate ? _rate : 0);
						}
					}
					this.fnAttendanceChart();
				}
			})
			.catch(err => {
				// this.$message.error(err.data);
			});
		},
		// 获取安全统计数据
		fnGetSafetyData(){
			request({
			  url: "qualitySafe/safeCount",
			  method: "GET",
			})
			.then(res => {
				if(res.data&&res.data.rectify){
					that.safety.safetyTotal = res.data.rectify.total
					that.safety.safetyTimeout = res.data.rectify.ed.timeout_num
					that.safety.safetyTime = res.data.rectify.ed.time_num
					that.safety.safetyIng = res.data.rectify.ing.ing_num
					that.safety.safetyNot = res.data.rectify.not.not_num
					that.$nextTick(()=>{
						// 调用初始化安全统计图
						that.fnSafetyRateChart()
					})
				}
			})
			.catch(err => {
				that.$message.error(err.data);
			});
		},
		// 初始化安全统计图
		fnSafetyRateChart() {
			that.safetyRateChart = echarts.init(that.$refs.safetyRate);
			that.safetyRateChart.setOption({
				title: {
					// text: '安全统计',
					left: '20px',
					textStyle: {
						color: '#fff'
					}
				},
				tooltip: {
					trigger: 'item',
					formatter: '{a} <br/>{b}: {c} ({d}%)'
				},
				legend: {
					orient: 'vertical',
					x: 'left',
					show: false,
					data: ['准时整改', '超时整改', '未整改','整改中']
				},
				series: [
					{
						name: '安全统计',
						type: 'pie',
						radius: ['50%', '70%'],
						avoidLabelOverlap: false,
						label: {
							show:false,
							position: 'center'
						},
						emphasis: {
							label:{
								show: true,
								fontSize: '16',
								fontWeight: 'bold'
							}
						},
						labelLine: {
							normal: {
								show: false
							}
						},
						data: [
							{ value: that.safety.safetyNot, name: '未整改'},
							{ value: that.safety.safetyIng, name: '整改中'},
							{ value: that.safety.safetyTime, name: '准时整改'},
							{ value: that.safety.safetyTimeout, name: '超时整改'},
						]
					}
				]
			});
		},
		// 获取质量统计数据
		fnGetQualityData(){
			request({
				url: "qualitySafe/qualityCount",
				method: "GET",
			})
			.then(res => {
				if(res.data&&res.data.rectify){
					that.quality.qualityTotal = res.data.rectify.total
					that.quality.qualityTimeout = res.data.rectify.ed.timeout_num
					that.quality.qualityTime = res.data.rectify.ed.time_num
					that.quality.qualityIng = res.data.rectify.ing.ing_num
					that.quality.qualityNot = res.data.rectify.not.not_num
					that.$nextTick(()=>{
						// 调用初始化质量统计图
						that.fnQualityRateChart()
					})
				}
			})
			.catch(err => {
				this.$message.error(err.data);
			});
		},
		// 初始化质量统计图
		fnQualityRateChart() {
			that.qualityRateChart = echarts.init(that.$refs.qualityRate);
			that.qualityRateChart.setOption({
				title: {
					// text: '质量统计',
					left: '20px',
					textStyle: {
						color: '#fff'
					}
				},
				tooltip: {
					trigger: 'item',
					formatter: '{a} <br/>{b}: {c} ({d}%)'
				},
				legend: {
					orient: 'vertical',
					x: 'left',
					show: false,
					data: ['准时整改', '超时整改', '未整改','整改中']
				},
				series: [
					{
						name: '质量统计',
						type: 'pie',
						radius: ['50%', '70%'],
						avoidLabelOverlap: false,
						label: {
							show:false,
							position: 'center'
						},
						emphasis: {
							label:{
								show: true,
								fontSize: '16',
								fontWeight: 'bold'
							}
						},
						labelLine: {
							normal: {
								show: false
							}
						},
						data: [
							{ value: that.quality.qualityNot, name: '未整改'},
							{ value: that.quality.qualityIng, name: '整改中'},
							{ value: that.quality.qualityTime, name: '准时整改'},
							{ value: that.quality.qualityTimeout, name: '超时整改'},
						]
					}
				]
			});
		},
	}
};
</script>

<style scoped lang="scss">
@import '~@/styles/mixin.scss';
@import '@/assets/css/base.scss';
.hello {
	width: 100vw;
	height: 100vh;
	background: url('../../../assets/images/app_bg.jpg') no-repeat;
	background-size: 100% 100%;
	position: relative;
	overflow: hidden;
	.hello_box{
		position: absolute;
		left: 0;
		right: -20px;
		top: 0;
		bottom: 0;
		overflow-x: hidden;
		overflow-y: auto;
	}
}
.contBox {
	box-sizing: border-box;
	width: 1920px;
	height: 950px;
	padding: 0 20px;
	position: absolute;
	top: 108px;
	left: 0;
	display: flex;
	justify-content: space-around;
	& > div {
		width: 490px;
		height: 100%;
		display: flex;
		flex-direction: column;
	}
	.resources {
		background: url('../../../assets/images/title_bg.png') no-repeat;
		background-size: 100% 100%;
	}
	.property {
		position: relative;
		margin-top: -108px;
		flex: 1;
		display: flex;
		align-items: center;
        .marker_box{
            // margin: 70px 0 10px 0;
            margin: 152.8px 4.2px 70px 5px;
            // width: 830px;
            // height: 680px;
            width: 820.8px;
            height: 547.2px;
            // border-radius: 50%;
            overflow: hidden;
            border: 1px solid #3a74dd;
            background-color: rgba(49, 88, 128, 0.1);
        }
		.property_top {
			position: relative;
			width: 88%;
			height: 760px;
			margin-top: 48px;
			.pic1 {
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				width: 100%;
				height: 100%;
				margin: auto;
				border-radius: 50%;
				background: url('../../../assets/images/menu_bg@2x.png') no-repeat;
				background-size: 100% 100%;
			}
			.pic2 {
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				width: 750px;
				height: 750px;
				margin: auto;
				border-radius: 50%;
				background: url('../../../assets/images/menu_Clockwise@2x.png') no-repeat;
				background-size: 100% 100%;
				z-index: 110;
				animation: mymove1 180s infinite linear;
			}
			.pic3 {
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				width: 500px;
				height: 500px;
				margin: auto;
				border-radius: 50%;
				background: url('../../../assets/images/menu_center_anticlockwise@2x.png') no-repeat;
				background-size: 100% 100%;
				animation: mymove2 48s infinite linear;
			}
			.pic4 {
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				width: 480px;
				height: 480px;
				margin: auto;
				border-radius: 50%;
				background: url('../../../assets/images/menu_quan01@2x.png') no-repeat;
				background-size: 100% 100%;
				animation: mymove3 36s infinite linear;
			}
			.pic5 {
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				width: 175px;
				height: 175px;
				margin: auto;
				border-radius: 50%;
				background: url('../../../assets/images/menu_Immobility@2x.png') no-repeat;
				background-size: 100% 100%;
				z-index: 999;
				color:#44ffff;
				text-align: center;
				font-size: 32px;
				.text{
					margin-top: 64px;
				}
			}
			.pic6 {
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				width: 618px;
				height: 618px;
				margin: auto;
				border-radius: 50%;
				background: url('../../../assets/images/menu_content@2x.png') no-repeat;
				background-size: 100% 100%;
				z-index: 99;
				animation: mymove4 180s infinite linear;
			}
			.pic7 {
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				width: 440px;
				height: 440px;
				margin: auto;
				border-radius: 50%;
				background: url('../../../assets/images/menu_div@2x.png') no-repeat;
				background-size: 100% 100%;
				z-index: 666;
				animation: mymove1 180s infinite linear;
			}
			&:hover {
				cursor: url('../../../assets/images/WechatIMG88.gif'), auto;
			}
		}
		.property_bottom {
			position: absolute;
			bottom: -109px;
			left: 36px;
			width: 830px;
			height: 300px;
			background: url('../../../assets/images/title_bg_wy.png') no-repeat;
			background-size: 100% 100%;
			.property_bottom_title {
				width: 100%;
				height: 40px;
				display: flex;
                cursor: pointer;
				align-items: center;
				.line {
					width: 5px;
					height: 10px;
					background: rgba(6, 177, 255, 1);
					margin: 0 9px 0 20px;
				}
				h4 {
					font-size: 22px;
					color: rgba(6, 177, 255, 1);
				}
			}
			.property_bottom_content {
				display: flex;
				justify-content: space-around;
				width: 100%;
				height: 240px;
				margin-top: 20px;
				.video{
					width: 49%;
				}
				img{
					width: 49%;
				}
			}
		}
	}
	.firstTitle {
		width: 100%;
		height: 40px;
		display: flex;
		align-items: center;
		.line {
			width: 5px;
			height: 20px;
			background: rgba(238, 187, 108, 1);
			margin: 0 9px 0 20px;
		}
		h4 {
			font-size: 22px;
			color: rgba(238, 187, 108, 1);
		}
	}
	.title {
		width: 440px;
		height: 16px;
		background: url('../../../assets/images/title_subline_zy.png') no-repeat;
		background-size: 100% 100%;
		position: relative;
        cursor: pointer;
		span {
			font-size: 18px;
			font-family: Adobe Heiti Std R;
			color: rgba(238, 187, 108, 1);
			position: absolute;
			top: -14px;
		}
	}
	.lease {
		height: 110px;
		padding: 0 20px 0 18px;
		box-sizing: border-box;
		margin-top: 24px;
	}
	.allArea {
		height: 70px;
		display: flex;
		color: #FFFFFF;
		background-color: rgba(57, 117, 174, 0.15);
		margin: 5px 0;
		.swiper-containers {
			width: 490px;
			height: 70px;
			overflow: hidden;
			@include flex-box(space-around,center);
			.swiper-wrapper {
				height: 70px;
				.swiper-slide {
					height: 70px;
					text-align: right;
				}
			}
		}
		.abnormal{
			width: 490px;
			height: 70px;
			text-align: center;
			font-size: 12px;
            cursor: pointer;
			@include flex-box(space-around,center);
            .names{
                width: 60px;
                height: 70px;
                margin-left: 20px;
                @include  flex-box(center,center);
            }
			.avatars{
                margin-left: 10px;
				@include  flex-box(center,center);
				img{
					width: 60px;
					height: 60px;
					border-radius: 50%;
				}
			}
            .conts{
                width: 310px;
                height: 70px;
                line-height: 70px;
                text-align: left;
                overflow:hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
                margin: 0 20px 0 10px;
            }
		}
	}
	.attendance{
		height: 300px;
		padding: 0 20px 0 18px;
		box-sizing: border-box;
		.attendance-chart{
			height: 270px;
		}
	}
	.businessmen {
		height: 260px;
		padding: 0 20px 0 18px;
		box-sizing: border-box;
		.content-boxs{
			height: 230px;
			@include flex-box(space-around,center);
			.quality,.safety{
				width: 230px;
				height: 230px;
				.titles{
					width: 230px;
					height: 40px;
					line-height: 40px;
					color: #FFFFFF;
					font-size: 16px;
                    cursor: pointer;
					@include flex-box(flex-start,center);
					img{
						width: 16px;
						height: 16px;
						margin-right: 5px;
					}
				}
				.charts{
					position: relative;
					width: 230px;
					height: 190px;
					@include flex-box(center,center);
					.quality-rate,.safety-rate{
						position: absolute;
						width: 180px;
						height: 180px;
					}
				}
			}
		}
	}
	// 设备统计
	.administrationServer {
		height: 230px;
		padding: 0 20px 0 18px;
		box-sizing: border-box;
	}
	.wrapper {
		height: 188px;
		margin-top: 10px;
		position: relative;
	}
	.huan1 {
		width: 100px;
		height: 100px;
		background: url('../../../assets/images/device_bg.png') no-repeat;
		background-size: 100% 100%;
		text-align: center;
        cursor: pointer;
		img {
			width: 30px;
			height: 30px;
			margin-top: 10px;
			margin-left: 33px;
			display: block;
		}
		span {
			display: block;
			font-size: 14px;
			color: rgba(255, 255, 255, 1);
		}
		.span1 {
			margin: 2px 0;
			font-size: 12px;
		}
	}
	.position1 {
		position: absolute;
		left: 20;
		top: 4px;
		animation: mymove6 5s linear infinite;
	}
	.position2 {
		position: absolute;
		left: 120px;
		top: 4px;
		animation: mymove6 5s linear infinite;
	}
	.position3 {
		position: absolute;
		left: 235px;
		top: 4px;
		animation: mymove6 5s linear infinite;
	}
	.position4 {
		position: absolute;
		left: 345px;
		top: 4px;
		animation: mymove6 5s linear infinite;
	}
	.position5 {
		position: absolute;
		left: 60px;
		top: 85px;
		animation: mymove6 5s linear 3s infinite;
	}
	.position6 {
		position: absolute;
		left: 175px;
		top: 85px;
		animation: mymove6 5s linear 3s infinite;
	}
	.position7 {
		position: absolute;
		left: 290px;
		top: 85px;
		animation: mymove6 5s linear 3s infinite;
	}
	.energy {
		background: url('../../../assets/images/title_bg.png') no-repeat;
		background-size: 100% 100%;
		background-color: linear-gradient(0deg, rgba(245, 101, 61, 0.73), rgba(250, 140, 110, 0.73));
		border: 2px solid rgba(2, 245, 247, 0.1);
		.energy_title {
			width: 100%;
			height: 40px;
			display: flex;
			align-items: center;
			background: linear-gradient(90deg, rgba(32, 156, 255, 0.49), rgba(1, 5, 20, 0));
			.line {
				width: 5px;
				height: 20px;
				background: #6ceeaf;
				margin: 0 9px 0 20px;
			}
			h4 {
				font-size: 22px;
				color: #6ceeaf;
			}
		}
		.box_title {
			position: relative;
			width: 440px;
			height: 16px;
			margin: 32px auto 20px;
            cursor: pointer;
			background: url('../../../assets/images/title_subline_ny.png') no-repeat;
			background-size: 100% 100%;
			span {
				position: absolute;
				top: -14px;
				font-size: 18px;
				font-family: Adobe Heiti Std R;
				color: #6ceeaf;
			}
		}
		.warning_box {
			.list {
				box-sizing: border-box;
				display: flex;
				width: 430px;
				height: 40px;
				margin: 0 auto;
				padding: 0 16px;
				line-height: 40px;
				justify-content: space-between;
				.list_left {
					.left_logo {
						width: 20px;
						height: 20px;
						margin-right: 6px;
						vertical-align: middle;
					}
					.left_txt {
						font-size: 16px;
						font-weight: 600;
						vertical-align: middle;
					}
				}
				.list_right {
					font-size: 16px;
					color: #58b9fc;
					.right_logo {
						width: 20px;
						height: 20px;
						margin-right: 6px;
						vertical-align: middle;
					}
					.right_time {
						margin-right: 3px;
						vertical-align: middle;
					}
					.right_txt {
						vertical-align: middle;
					}
				}
			}
			.list_fitment {
				background: rgba(57, 117, 174, 0.15);
				.left_txt {
					background: linear-gradient(0deg, rgba(7, 235, 159, 0.73) 0%, rgba(162, 252, 222, 0.73) 100%);
					-webkit-background-clip: text;
					-webkit-text-fill-color: transparent;
				}
			}
			.list_roadshow .left_txt {
				background: linear-gradient(0deg, rgba(245, 101, 61, 0.73) 0%, rgba(250, 140, 110, 0.73) 100%);
				-webkit-background-clip: text;
				-webkit-text-fill-color: transparent;
			}
			.list_shangbao {
				background: rgba(57, 117, 174, 0.15);
				.left_txt {
					background: linear-gradient(0deg, rgba(7, 167, 177, 0.73) 0%, rgba(156, 243, 248, 0.73) 100%);
					-webkit-background-clip: text;
					-webkit-text-fill-color: transparent;
				}
			}
			.list_parking .left_txt {
				background: linear-gradient(0deg, rgba(174, 61, 227, 0.73) 0%, rgba(217, 141, 252, 0.73) 100%);
				-webkit-background-clip: text;
				-webkit-text-fill-color: transparent;
			}
			.list_repairs .left_txt {
				background: linear-gradient(0deg, rgba(6, 177, 255, 0.73) 0%, rgba(80, 199, 254, 0.73) 100%);
				-webkit-background-clip: text;
				-webkit-text-fill-color: transparent;
			}
		}
		.resource_box {
			.resource_content {
				box-sizing: border-box;
				display: flex;
				width: 100%;
				padding: 0 20px;
				justify-content: space-between;
				.resource_left_title {
					height: 40px;
					line-height: 40px;
					margin-top: -20px;
					.left_title_logo {
						width: 16px;
						height: 16px;
						vertical-align: middle;
					}
					span {
						font-size: 16px;
						color: #fefefe;
						vertical-align: middle;
					}
					.warning_count {
						margin-left: 8px;
						padding: 0 8px;
						font-size: 14px;
						background: #124e62;
						color: #fa2828;
						vertical-align: middle;
					}
				}
				.resource_left {
					width: 100%;
					.water_electricity {
						display: flex;
						justify-content: space-between;
						.water_electricity_box {
							width: 85px;
							.water_electricity_title {
								width: 100%;
								height: 32px;
								margin-bottom: 6px;
								line-height: 32px;
								font-size: 14px;
								text-align: center;
								background: url('../../../assets/images/ny_div.png') no-repeat;
								background-size: 100% 100%;
								&.water_title {
									color: #78fd30;
								}
								&.electricity_title {
									color: #d2c820;
								}
							}
							.water_box_count {
								box-sizing: border-box;
								width: 100%;
								height: 40px;
								line-height: 40px;
								font-size: 16px;
								background: url('../../../assets/images/fny_frame@2x.png') no-repeat;
								background-size: 100% 100%;
								.water_box_txt {
									display: block;
									color: #2ccad9;
								}
								.water_box_txt1 {
									display: block;
									text-align: center;
									color: #28b2fa;
								}
							}
						}
					}
					.trouble_box {
						width: 100%;
						margin-top: 30px;
						margin-bottom: 46px;
						.trouble_title {
							height: 32px;
							line-height: 32px;
							font-size: 14px;
							text-align: center;
							background: url('../../../assets/images/ny_gz_bg@2x.png') no-repeat;
							background-size: 100% 100%;
							color: #62afdf;
						}
						.trouble_content {
							display: flex;
							align-items: center;
							height: 54px;
							margin-top: 6px;
							line-height: 54px;
							font-size: 24px;
							text-align: center;
							background: url('../../../assets/images/ny_gz_frame@2x.png') no-repeat;
							background-size: 100% 100%;
							color: #fa2828;
							p {
								flex: 1;
								height: 28px;
								line-height: 28px;
							}
							.trouble_count {
								border-right: 2px solid #229cdd;
							}
						}
					}
					.resource_right_content {
						box-sizing: border-box;
						width: 100%;
						height: 290px;
						border: 4px solid rgba(19, 106, 183, 0.5);
						border-radius: 6px;
						.right_content_title {
							height: 30px;
							line-height: 30px;
							font-size: 12px;
							text-indent: 18px;
							background: url('../../../assets/images/ny_chart_title_bg@2x.png') no-repeat;
							background-size: 100% 100%;
							color: #bac2cc;
						}
						.lineData{
							height: 250px;
							position: relative;
							.open-dateils {
								position: absolute;
								right: 30px;
								top: 20px;
							}
							.chart-container {
								position: relative;
								height: 250px;
								cursor: pointer;
							}
						}
					}
				}
				.resource_right {
					width: 232px;
					.resource_right_top {
						display: flex;
						justify-content: space-between;
						.right_top_item {
							width: 100px;
							.right_top_count {
								width: 100%;
								height: 25px;
								line-height: 25px;
								border: 2px solid rgba(19, 106, 183, 0.5);
								border-radius: 6px;
								font-size: 16px;
								text-align: center;
								color: #28b2fa;
							}
						}
					}
				}
			}
		}
	}
}
@keyframes mymove1 {
	0% {
		transform: rotate(0) scale(1);
	}
	50% {
		transform: rotate(360deg) scale(1.1);
	}
	100% {
		transform: rotate(0deg) scale(1);
	}
}
@keyframes mymove2 {
	0% {
		transform: rotate(0);
	}
	50% {
		transform: rotate(-120deg);
	}
	100% {
		transform: rotate(0deg);
	}
}
@keyframes mymove3 {
	0% {
		transform: rotate(0);
	}
	50% {
		transform: rotate(-180deg);
	}
	100% {
		transform: rotate(0deg);
	}
}
@keyframes mymove4 {
	0% {
		transform: rotate(0) scale(1);
	}
	50% {
		transform: rotate(-360deg) scale(1.1);
	}
	100% {
		transform: rotate(0deg) scale(1);
	}
}
@keyframes mymove5 {
	0% {
		transform: rotate(0);
	}
	100% {
		transform: rotate(360deg);
	}
}
@keyframes mymove6 {
	0% {
		transform: scale(1);
		opacity: 1;
	}
	50% {
		transform: scale(0.85);
		opacity: 0.5;
	}
	100% {
		transform: scale(1);
		opacity: 1;
	}
}
</style>



// WEBPACK FOOTER //
// src/views/ProjectIndex/indexDefault/index.vue